import { isEqual } from 'lodash'
import { create } from 'zustand'

import { StreamEventStore } from '@/stores/useStreamEventStore/useStreamEventStore.types'
import { StreamEvent } from '@/types/streams/event'

export const useStreamEventStore = create<StreamEventStore>((set, get) => ({
  streamEvent: null,
  setStreamEvent: (streamEvent: StreamEvent) => {
    if (!isEqual(streamEvent, get().streamEvent)) {
      set({
        streamEvent
      })
    }
  }
}))
